import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../api/quarkusApi';

export function useMedicines() {
  const navigate = useNavigate();

  const [medicines, setMedicines] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchMedicines = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/medicines', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => setMedicines(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchMedicines();
  }, [fetchMedicines]);

  return { medicines, isLoading, error, refetch: fetchMedicines };
}
